import React from "react";
import PropTypes from "prop-types";
import "./style.scss";

/**
 * LanguageSwapper
 *  - Lists some buttons that let you swap between languages
 */
export function LanguageSwapper(props) {
  const renderLanguageButton = (language, key) => (
    <LanguageButton key={key} language={language} onClick={props.onSelect} />
  );

  const renderLangageList = () => props.languageList.map(renderLanguageButton);

  return <div className="scrolly-language-swapper">{renderLangageList()}</div>;
}

LanguageSwapper.propTypes = {
  /**
   * List languages for which buttons should be displayed
   */
  languageList: PropTypes.arrayOf(PropTypes.string).isRequired,
  /**
   * Callback function to be executed when a language is selected
   */
  onSelect: PropTypes.func.isRequired,
};

LanguageSwapper.defaultProps = {
  languageList: [],
};

/**
 * LanguageButton
 *  - Button displayed for a language
 */
const LanguageButton = (props) => {
  const onClick = () => props.onClick(props.language);

  return <button onClick={onClick}>{props.language}</button>;
};

LanguageButton.propTypes = {
  /**
   * String code for a particular language
   */
  language: PropTypes.string.isRequired,
  /**
   * Callback function to be executed when button is clicked
   */
  onClick: PropTypes.func.isRequired,
};
